import React, {
	useState,
	useEffect,
	useCallback,
} from 'react';
import {
 	useSelector,
 	useDispatch,
} from 'react-redux';
import {
	actionSetMessage,
	actionResetMessages
} from 'components/messages/actions.js';
import { CheckAuth } from 'pages/auth/actions.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Container from 'react-bootstrap/Container';
import OPWBreadcrumb from 'components/breadcrumb.js';
//import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { actionFetchWeightChartData, getDownloadFile } from './actions.js';
import { ClientSessionSelect } from 'components/clientSessionSelect/clientSessionSelect.js';
import { GenericDictSelect } from 'components/genericDictSelect.js'
import Loading from 'components/loading.js';
import c3 from 'c3';
import 'c3/c3.min.css';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
//import { Link } from "react-router-dom";
import RptBtns from 'components/rptBtns.js';
import { saveAs } from 'file-saver'
import './weightChart.css';


const TITLE = 'Weight chart'
//const SUBTITLE = 'Average Daily Gain (ADG - shaded area)'
const BC = OPWBreadcrumb;

/*= () =>{
	return (
		<Breadcrumb>
			<Breadcrumb.Item linkAs={Link} linkProps={{to: '/'}}>Home</Breadcrumb.Item>
			<Breadcrumb.Item linkAs={Link} linkProps={{to: '/'}}>Reports</Breadcrumb.Item>
			<Breadcrumb.Item active>Weight Chart</Breadcrumb.Item>
		</Breadcrumb>
	)
}*/

const ParamPanel = (props) => {
	//const {loading, handleDownload, downloading, timePeriod, setTimePeriod, includeCurrentDay, setIncludeCurrentDay} = props;
	const {loading, handleDownload, downloading, timePeriod, setTimePeriod } = props;

	// const handleCurrentDayChange = (evt) => {
	// 	setIncludeCurrentDay(evt.target.checked);
	// 	console.log('evt.target.checked', evt.target.checked)
	// }

	return (
		<Card
			className={'no-print'}
			body
		>
			<Card.Title>{TITLE}</Card.Title>
			<Card.Body>
			<Row>
				<Col sm={ 4 }>
					<ClientSessionSelect
						layout = { 'select' }
						hideSessionSelect = { false }
						handleBeforeSessionChange = { ()=>{} }
						lock = { loading }
					/>
				</Col>
				<Col sm={ 4 }>
					<TimePeriodSelect
						setTimePeriod = { setTimePeriod }
						value = { timePeriod}
					/>
					{/*<Form.Check
						inline
						label = 'include current day'
						id = 'include-current-day'
						onChange = { handleCurrentDayChange }
						style = {{marginTop: '1em'}}
						value = { includeCurrentDay }
					/>*/}
				</Col>
				<Col sm={ 4 }>
					<div className={'text-right report-buttons'}>
						<RptBtns
							enablePrint = { true }
							enableHelp = { false }
							enableDownload = { true }
							//handleDownload = {() => { alert('Optiweigh feature coming soon - thanks for your patience.') }}
							handleDownload = {() => handleDownload()}
							downloading = { downloading }
						/>
					</div>
				</Col>
			</Row>
			</Card.Body>
		</Card>
	)
}

export const TimePeriodSelect = (props) => {
	const {setTimePeriod, value} = props;
	const timePeriodChoices = {
		Date30: 'Last 30 days',
		Date90: 'Last 90 days',
		Date180: 'Last 180 days',
		DateAll: 'All days',
	}
	const handleChangeEvt = (evt) => {
		evt.persist();
		//console.log('evt.target.value', evt.target.value)
		setTimePeriod(evt.target.value);
	}

	return (
		<>
			<GenericDictSelect
				id = 'moving-avg-timebase'
				label = 'Date Period'
				dataDict = { timePeriodChoices }
				cols = {{lhs:4, rhs:8}}
				controlStyle = { {width: '15em'} }
				handleChange = {(evt) => handleChangeEvt(evt)}
				value = { value }
				required = { 'sm' }
				selectDotDotDot = { false }
				loading = { false }
			/>
		</>
	)
}


export const WeightChart = (props) => {
	/**
	 *
	 *
	 *
	 */

	//const [visible, setVisible] = useState(true);
	const [columns, setColumns] = useState([]);//	local data for graph or report
	const [data01, setData01] = useState([]);//	data for chart01
	const [data02, setData02] = useState([]);//	data for chart02
	const [loading, setLoading] = useState(false);//	local data for graph or report
	const [downloading, setDownloading] = useState(false);
	const session = useSelector(state => state.session);
	//const sessionId = useSelector(state => state.sessionId);
	//const clientId = useSelector(state => state.clientId);
	const [c3Package01, setC3Package01] = useState(null);//	package for the c3 graph
	const [c3Package02, setC3Package02] = useState(null);//	package for the c3 graph
	const [timePeriod, setTimePeriod] = useState('Date30');
	const [includeCurrentDay, setIncludeCurrentDay] = useState(false);

	const dispatch = useDispatch()
		//the selected product - state variable
	//const messages = useSelector(state => state.messages);	// get from redux store
	//console.log('messages', messages)
	//var messages = []
	useEffect(() => {
		document.title = TITLE
	},[])

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	)

	useEffect(() => {
		dispatch(actionResetMessages())
		async function fetchData() {
			setLoading(true)
			const resp = await actionFetchWeightChartData(session.SessionID, timePeriod, includeCurrentDay, showMessage, setLoading)
			setColumns(resp)
		}
		if (session.SessionID > 0){
			fetchData();
		}
	},[session, timePeriod, includeCurrentDay, showMessage, dispatch])

	const handleDownload = async () => {
		setDownloading(true);
		const { data } = await getDownloadFile(session.SessionID, timePeriod, includeCurrentDay)
		await saveAs(data, 'weight_chart.csv')
		setDownloading(false);
	}

	useEffect(() =>{
		// we need to split the api response data into 2 sets for presentation

		const tmpData01 = columns.reduce(function (res, set) {
			//let dsum = 0;
			//let dcount = 0;
			//console.log('set01', set)
			if (set[0] === 'date' || set[0] === 'avg_wt' || set[0] === 'ma5' || set[0] === 'ma10' || set[0] === 'adg'){
				res.push([...set])
			}
			//res.push({...set, ...{weekAvg: weekAverage}})
			return res;
		}, []);
		setData01(tmpData01);

		const tmpData02 = columns.reduce(function (res, set) {
			//let dsum = 0;
			//let dcount = 0;
			//console.log('set02', set)

			if (set[0] === 'date' || set[0] === 'CountWt' || set[0] === 'animalCount' || set[0] === 'recordsPerAnimal'){
				res.push([...set])
			}
			//res.push({...set, ...{weekAvg: weekAverage}})
			return res;
		}, []);
		setData02(tmpData02);

	},[columns])

	useEffect(() =>{
		//console.log('data01', data01);
		const axis01 = {
			x: {
				type: 'timeseries',
				label: {
					text: 'Measurement Date',
					position: 'outer-center'
				},
				tick: {
					format: '%Y-%m-%d',
					rotate: 0,
					multiline: true
				}
			},
			y: {
				label: {
					text: 'Weight (kg)',
					position: 'outer-middle'
				}
			},
			y2: {
				show: true,
				label: {
					text: 'Average daily gain[kg/day]',
					position: 'outer-middle'
				}
			},
		}

		// const size = {height: 240, width: 480}
		// const padding = {top: 40,right: 100,bottom: 40,left: 100,}

		const config01 = {
			x: 'date',
			//type: 'spline',
			types: {
				adg: 'area-spline',
				ma10: 'spline',
			},
			axes: {
				ma5: 'y',
				ma10: 'y',
				avg_wt: 'y',
				adg: 'y2'
			},
			zoom: {
				enabled: true
			},
			names: {
				adg: 'ADG',
				avg_wt: 'Raw weight [kg]',
				ma5: 'Rolling mob average (5 day)[kg]',
				ma10: 'Rolling mob average (10 day)[kg]',
			},
			transition: {
				duration: 1000
			},
		};

		// setC3Package01({bindto: "#chart01", data: {...{columns: data01}, ...config01}, axis: axis01})
		//console.log('debug:', {...{columns: data01}, ...config01})
		setC3Package01({bindto: "#chart01", data: {...{columns: data01}, ...config01}, axis: axis01})

	},[data01])

	useEffect(()=>{
		if (c3Package01 !== null){
			//console.log('c3Package01',c3Package01)
			try {
			   c3.generate(c3Package01)
			} catch (error) {
				console.log('ERR initialising chart01', error)
				dispatch(actionSetMessage('ERR initialising chart: ' + JSON.stringify(error)))
			}
		}
   },[c3Package01, dispatch])

	useEffect(() =>{
		//console.log('data02', data02);
		const axis02 = {
			x: {
				type: 'timeseries',
				label: {
					text: 'Measurement Date',
					position: 'outer-center'
				},
				tick: {
					format: '%Y-%m-%d',
					rotate: 0,
					multiline: true
				}
			},
			y: {
				label: {
					text: 'Number',
					position: 'outer-middle'
				}
			},
			// y2: {
			// 	show: true,
			// 	label: {
			// 		text: 'Average daily growth (ADG)[kg]',
			// 		position: 'outer-middle'
			// 	}
			// },
		}

		// const size = {height: 240, width: 480}
		// const padding = {top: 40,right: 100,bottom: 40,left: 100,}

		const config02 = {
			x: 'date',
			type: 'bar',
			// types: {
			// 	adg: 'area-spline',
			// 	ma10: 'spline',
			// },
			axes: {
				CountWt: 'y',
				animalCount: 'y',
				recordsPerAnimal: 'y',
				// adg: 'y2'
			},
			zoom: {
				enabled: true
			},
			names: {
				CountWt: 'Weight count',
				animalCount: 'Animal count',
				recordsPerAnimal: 'Records/Animal',
			},
			transition: {
				duration: 1000
			},
		};
		setC3Package02({bindto: "#chart02", data: {...{columns: data02}, ...config02}, axis: axis02})
	},[data02])

	useEffect(()=>{
		if (c3Package02 !== null){
			//console.log('c3Package02',c3Package02)
			try {
			c3.generate(c3Package02)
			} catch (error) {
				console.log('ERR initialising chart02', error)
				dispatch(actionSetMessage('ERR initialising chart: ' + JSON.stringify(error)))
			}
		}
	},[c3Package02, dispatch])

	if (columns.length === 0){
		const msg = (loading)?'Loading data...':'No data for this session.';

		return (
			<Template
				loading = { loading }
				downloading = { downloading }
				handleDownload = { handleDownload }
				timePeriod = { timePeriod }
				setTimePeriod = { setTimePeriod }
				includeCurrentDay = { includeCurrentDay }
				setIncludeCurrentDay = { setIncludeCurrentDay }
			>
				<Alert className = { 'text-center' } variant={'secondary'} style={{backgroundColor: 'rgb(233,236,239)'}}>
					<Loading loading = { loading } />
					<h2>{ msg }</h2>
				</Alert>
			</Template>
		)
	} else {
		return (
				<Template
					loading = { loading }
					downloading = { downloading }
					handleDownload = { handleDownload }
					timePeriod = { timePeriod }
					setTimePeriod = { setTimePeriod }
					includeCurrentDay = { includeCurrentDay }
					setIncludeCurrentDay = { setIncludeCurrentDay }
				>
					<h2 className={'only-print'}>Optiweigh - Weight chart</h2>
					<Loading loading = { loading } />
					<div id='chart01' />
					<br />
					<hr />
					<br />
					<div id='chart02' />
				</Template>
		)
	}
}

const Template = (props) => (
	<div>
		<Header><BC trail='[["Home", "/"], ["reports", "/"], ["weight chart", ""]]' /></Header>
		<Container fluid className="body">
			<CheckAuth groupName = { 'user' }/>
			{/*<h2 className='text-center'>{ TITLE }</h2>*/}
			<ParamPanel {...props}
				//loading = { props.loading }
				//downloading = { props.downloading }
				//handleDownload = { props.handleDownload }
			/>
			{/* <h3 style={{backgroundColor: 'yellow'}}>** we are currently working on this - we appreciate your patience (30/11/2020)</h3> */}
			{/* <h3 className='text-center'>{ SUBTITLE }</h3> */}
			{ props.children }
		</Container>
		<Container fluid>
			<Row>
				<Col sm='12'>
					<Footer />
				</Col>
			</Row>
		</Container>
	</div>
)